import { OneTrustSettingsButtonAdapter } from "./OneTrustSettingsButton";

export { OneTrustSettingsButtonAdapter as OneTrustSettingsButton };
